module.exports = __webpack_public_path__ + "static/media/fork-knife.02ce8133.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/fork-knife.svg
// module id = 2952
// module chunks = 7